import React from 'react';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import LockIcon from '@mui/icons-material/Lock';
import LogoutIcon from '@mui/icons-material/Logout';
import { lzFKebabToWordCase } from '@lz/services/String';
import LzCModule from '../Module';
import LzXPageNavParent from '@lz/components/screens/commons/NavParent';
import { LzTNavItems } from '@lz/components/layout/Navigation/types';
import LzXPageLogin from '@lz/components/screens/public/user/Login';
import LzXPageForgotPassword from '@lz/components/screens/public/user/ForgotPassword';
import LzXPageResetPassword from '@lz/components/screens/public/user/ResetPassword';
import LzXPageRegister from '@lz/components/screens/public/user/Register';
import LzXPageProfile from '@lz/components/screens/private/user/Profile';
import LzXPageChangePassword from '@lz/components/screens/private/user/ChangePassword';
import LzXPageLogout from '@lz/components/screens/private/user/Logout';

interface LzPUserModule {
    ident?: string,
    name?: string,
    baseRoute?: string,
    slug?: string,
    icon?: React.ReactNode,
    noRegistration?: boolean,
    loginPage?: React.ReactNode,
    forgotPwdPage?: React.ReactNode,
    resetPwdPage?: React.ReactNode,
    registerPage?: React.ReactNode,
    profilePage?: React.ReactNode,
    changePasswordPage?: React.ReactNode,
    logoutPage?: React.ReactNode,
};

class LzYUser extends LzCModule {

    constructor(props: LzPUserModule) {

        const ident = props?.ident || 'user';
        const name = props?.name || lzFKebabToWordCase(ident);
        const baseRoute = props?.baseRoute || '/';
        const slug = props?.slug || ident;
        const moduleRoute = baseRoute + slug;
        const noRegistration = typeof props?.noRegistration === 'undefined' ? false : props.noRegistration;

        const loginPage = props?.loginPage || <LzXPageLogin hideCreateAccountLink={noRegistration} />;
        const forgotPwdPage = props?.forgotPwdPage || <LzXPageForgotPassword />;
        const resetPwdPage = props?.resetPwdPage || <LzXPageResetPassword />;
        const registerPage = props?.registerPage || <LzXPageRegister />;

        const profilePage = props?.profilePage || <LzXPageProfile />;

        const changePasswordPage = props?.changePasswordPage || <LzXPageChangePassword />;

        const logoutPage = props?.logoutPage || <LzXPageLogout />;

        const navItems: LzTNavItems = [
            {
                key: 'user',
                icon: props?.icon || <AccountCircleIcon />,
                title: name,
                children: [
                    { key: 'profile', icon: <ManageAccountsIcon />, title: 'Update Profile', route: moduleRoute + '/profile' },
                    { key: 'password', icon: <LockIcon />, title: 'Change Password', route: moduleRoute + '/password' },
                    { key: 'logout', icon: <LogoutIcon />, title: 'Logout', route: moduleRoute + '/logout' },
                ],
            },
        ];

        const routes = [
            { path: moduleRoute, element: <LzXPageNavParent private navItems={navItems} /> },
            { path: moduleRoute + '/login', element: loginPage },
            { path: moduleRoute + '/forgot-pwd', element: forgotPwdPage },
            { path: moduleRoute + '/reset-pwd', element: resetPwdPage },
            { path: moduleRoute + '/register', element: registerPage },
            { path: moduleRoute + '/profile', element: profilePage },
            { path: moduleRoute + '/password', element: changePasswordPage },
            { path: moduleRoute + '/logout', element: logoutPage },
        ];

        super({
            variation: 'Module',
            ident: ident,
            name: name,
            slug: slug,
            routes: routes,
            navItems: navItems,
        });

    }

}

export default LzYUser;
